import 'gis';

export default class Locator {

    private locator: any;

    private constructor(esriLocator: any) {
        this.locator = esriLocator;
    }

    public locationToISRS(location: any, distance: number): Promise<{ isrs: string, location: any }> {
        return new Promise((resolve, reject) => {
            var p = this.locationToAddress(location, distance);
            p.then((data) => {
                if (data && data.address && data.address.SingleKey) {
                    resolve({ isrs: data.address.SingleKey, location: data.location });
                } else {
                    reject('Not found');
                }
            }, (reason: any) => {
                reject(reason);
            });
        });
    }

    public locationToAddress(location: any, distance: number): Promise<{ address: any, location: any }> {
        return new Promise((resolve, reject) => {
            this.locator.locationToAddress(location, distance, (e: { address: any, location: any }) => {
                resolve(e);
            }, (e: any) => {
                reject(e);
            });
        });
    }

    public static create(url: string): Promise<Locator> {
        return new Promise((resolve, reject) => {
            import('esri/tasks/locator').then((EsriLocator: any) => { // tslint:disable-line:variable-name
                resolve(new Locator(new EsriLocator(url)));
            });
        });
    }

    public static buildPoint(x: number, y: number): Promise<any> {
        return new Promise((resolve, reject) => {
            import('esri/geometry/Point').then((EsriPoint: any) => { // tslint:disable-line:variable-name
                var point = new EsriPoint();
                point.x = x;
                point.y = y;
                point.spatialReference.wkid = 102100;
                resolve(point);
            });
        });
    }
}